import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  MeetingProvider,
  useMeeting,
  useParticipant,
  Constants,
} from "@videosdk.live/react-sdk";
import ReactPlayer from "react-player";
import Hls from "hls.js";
import PlaceholderImage from "../resources/elementor-placeholder-image.webp";

function SpeakerView() {
    const [joined, setJoined] = useState(null);
    //Get the method which will be used to join the meeting.
    //We will also get the participant list to display all participants
    const { participants } = useMeeting();
    const mMeeting = useMeeting({
      onMeetingJoined: () => {
        setJoined("JOINED");
        //we will pin the local participant if he joins in CONFERENCE mode
        if (mMeetingRef.current.localParticipant.mode == "CONFERENCE") {
          mMeetingRef.current.localParticipant.pin();
        }
      },
  });
  //We will create a ref to meeting object so that when used inside the
  //Callback functions, meeting state is maintained
  const mMeetingRef = useRef(mMeeting);
  useEffect(() => {
    mMeetingRef.current = mMeeting;
  }, [mMeeting]);
  //Filtering the host/speakers from all the participants
  const speakers = useMemo(() => {
    const speakerParticipants = [...participants.values()].filter(
      (participant) => {
        return participant.mode == Constants.modes.CONFERENCE;
      }
    );
    return speakerParticipants;
  }, [participants]);
  return (
    <div className="container">
      {joined && joined == "JOINED" ? (
            <div className="cont-video">
                {/* {speakers.map((participant) => ( */}
                    <ParticipantView
                    participantId={speakers[0].id}
                    key={speakers[0].id}
                    />
                {/* ))} */}
            <Controls />
            </div>
      ) : (
        <p>Getting things ready...</p>
      )}
    </div>
  );
}

function ParticipantView(props) {
    const micRef = useRef(null);
    const { webcamStream, micStream, webcamOn, micOn, isLocal, displayName } =
      useParticipant(props.participantId);
    const videoStream = useMemo(() => {
      if (webcamOn && webcamStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(webcamStream.track);
        return mediaStream;
      }
    }, [webcamStream, webcamOn]);
    
    useEffect(() => {
      if (micRef.current) {
        if (micOn && micStream) {
          const mediaStream = new MediaStream();
          mediaStream.addTrack(micStream.track);
          micRef.current.srcObject = mediaStream;
          micRef.current
            .play()
            .catch((error) =>
              console.error("videoElem.current.play() failed", error)
            );
        } else {
          micRef.current.srcObject = null;
        }
      }
    }, [micStream, micOn]);  

    return (
      <div>
        <audio ref={micRef} autoPlay playsInline muted={isLocal} />
        {webcamOn && (
          <ReactPlayer
            playsinline
            pip={false}
            light={false}
            controls={false}
            muted={true}
            playing={true}
            url={videoStream}
            height={"auto"}
            width={"98%"}
            onError={(err) => {
              console.log(err, "participant video error");
            }}
          />
        )}
      </div>
    );
    }

    function Controls() {
        const { hlsState, startHls, stopHls } = useMeeting();
      const _handleHLS = () => {
        console.log("hlsState", hlsState);
        if (!hlsState || hlsState === "HLS_STOPPED") {
          startHls({
            layout: {
              type: "SPOTLIGHT",
              priority: "PIN",
              gridSize: 4,
            },
            theme: "DARK",
            orientation: "landscape",
          });
        } else if (hlsState === "HLS_STARTED" || hlsState === "HLS_PLAYABLE") {
          stopHls();
        }
      };
        return (
          <>
            {hlsState === "HLS_STARTED" ||
            hlsState === "HLS_STOPPING" ||
            hlsState === "HLS_STARTING" ||
            hlsState === "HLS_PLAYABLE" ? (
              <button
                onClick={() => {
                  _handleHLS();
                }}
                style={{
                  backgroundColor: "#FF5D5D",
                }}
              >
                {hlsState === "HLS_STARTED"
                  ? "Live Starting"
                  : hlsState === "HLS_STOPPING"
                  ? "Live Stopping"
                  : hlsState === "HLS_PLAYABLE"
                  ? "Stop Live"
                  : "Loading..."}
              </button>
            ) : (
              <button
                onClick={() => {
                  _handleHLS();
                }}
                style={{
                  backgroundColor: "#FF5D5D",
                }}
              >
                Go Live
              </button>
            )}
          </>
        );
      };
      
const StartStream = () => {
    const [apiToken, setApiToken] = useState(null);

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [featuredImage, setFeaturedImage] = useState(null); 
    const [category, setCategory] = useState("");
    const [preacher, setPreacher] = useState("");
    const [placeholderImage, setPlacholderImage] = useState(PlaceholderImage);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setPlacholderImage(URL.createObjectURL(file));
        setFeaturedImage(file);
      };

  return (
    <div id="content">
      <h1>Start Stream</h1>
        <div className='row'>
          <div className='col-sm-8'>
            <div className='ev-basic-info'>
              <h4>Basic Info</h4>
                <br/>
                <div>
                    <img src={placeholderImage} width="35%"/>
                    <label style={{ cursor: 'pointer' }}  htmlFor="file-upload" className="custom-file-upload">
                        <b>Change Featured Image</b>
                    </label>
                    <input
                        id="file-upload"
                        type="file"
                        onChange={handleImageChange}
                        style={{ display: 'none' }} 
                    />
                </div>
              <label>Stream Title
              <br/> <input type="text" onChange={(e) => setTitle(e.target.value)}/></label>
              <label>Stream Description
              <br/> <textarea onChange={(e) => setDescription(e.target.value)}/></label>
              <label>Stream Category
              <br/> <input type="text" onChange={(e) => setCategory(e.target.value)}/></label>
              <label>Pastor/Preacher
              <br/> <input type="text" onChange={(e) => setPreacher(e.target.value)}/></label>
            </div>
          </div>
          <div className='col-sm-4' style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <div id="video-stream">
                <h4>Stream Preview</h4>
                <br/>
                <MeetingProvider
                    config={{
                        meetingId: "1pm8-gbmc-jfce",
                        micEnabled: true,
                        webcamEnabled: true,
                        name: "RRC Montana",
                    }}
                    joinWithoutUserInteraction
                    token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiJmMjY0NjRkZi01YjQ5LTRlMzEtOTg4ZS0xMzg1MDQ3NWE4MGIiLCJwZXJtaXNzaW9ucyI6WyJhbGxvd19qb2luIl0sImlhdCI6MTcyNjA1NjA2MywiZXhwIjoxNzI2MTQyNDYzfQ.rfM9VrD0DwpajCqxrdJWOPw1VF2M_clEKgNQZM9fULQ"
                    >
                        <SpeakerView />
                    </MeetingProvider>
                </div>
            </div>
        </div>
    </div>
  );
};

export default StartStream;